<template>
    <div class="" >
        <p class="cell-list" v-show="params.value !== null">
            <vx-tooltip color="primary" :text="(params.value)" position="bottom">
                <span>{{ params.value }}</span>
            </vx-tooltip>
        </p>
        <div v-show="params.value === null">
            <p class="cell-list">{{ params.value }}</p>
        </div>
    </div>
</template>

<script>
export default {
  name: 'CellRendererList'
}
</script>